var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegramCircle = function SvgTelegramCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2949_113976)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_2949_113976)",
    d: "M10.5 19.0778C15.4092 19.0778 19.3889 15.0981 19.3889 10.1889C19.3889 5.27972 15.4092 1.30003 10.5 1.30003C5.5908 1.30003 1.61111 5.27972 1.61111 10.1889C1.61111 15.0981 5.5908 19.0778 10.5 19.0778Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M5.63508 10.0946C8.22637 8.96564 9.9543 8.22134 10.8189 7.86173C13.2874 6.83498 13.8004 6.65663 14.1347 6.65067C14.2082 6.64944 14.3726 6.66766 14.4791 6.75408C14.5691 6.82705 14.5938 6.92562 14.6056 6.9948C14.6175 7.06399 14.6322 7.22159 14.6205 7.34473C14.4867 8.75027 13.9079 12.1612 13.6134 13.7354C13.4888 14.4015 13.2435 14.6249 13.006 14.6467C12.4898 14.6942 12.0978 14.3056 11.5978 13.9778C10.8155 13.465 10.3735 13.1458 9.61413 12.6453C8.73652 12.067 9.30544 11.7491 9.80559 11.2297C9.93648 11.0937 12.2108 9.02501 12.2549 8.83735C12.2604 8.81388 12.2655 8.72639 12.2135 8.68019C12.1615 8.63399 12.0848 8.64979 12.0295 8.66236C11.951 8.68017 10.7012 9.50623 8.28008 11.1406C7.92533 11.3842 7.60401 11.5028 7.31611 11.4966C6.99873 11.4898 6.38822 11.3172 5.93437 11.1696C5.3777 10.9887 4.93528 10.893 4.9738 10.5857C4.99387 10.4257 5.21429 10.262 5.63508 10.0946Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2949_113976",
    x1: 10.5,
    x2: 10.5,
    y1: 1.30003,
    y2: 18.9459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2949_113976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7778,
    height: 17.7778,
    fill: "white",
    transform: "translate(1.61111 1.30003)"
  })))));
};
export default SvgTelegramCircle;